import { createFileRoute, redirect } from "@tanstack/react-router";

/** Legacy: devoluciones bajo Órdenes. */
export const Route = createFileRoute("/app/devoluciones")({
  beforeLoad: ({ search }) => {
    const orderId = typeof (search as Record<string, unknown>).orderId === "string"
      ? (search as Record<string, string>).orderId
      : undefined;
    throw redirect({
      to: "/app/ordenes/devoluciones",
      search: (orderId ? { orderId } : {}) as never,
    });
  },
});
